import {
  List,
  Datagrid,
  TextField,
  EditButton,
  DeleteButton,
  ReferenceField,
  DateField,
  FunctionField,
  Pagination,
  TextInput,
  SelectInput,
} from 'react-admin'

import FilterComponent from '../../components/Filter'

const COLLECTION_TYPE = {
  book: 'Book',
  book_summary: 'Book summary',
}

const CollectionPagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 100, 1000]} {...props} />
)

const CollectionFilter = props => (
  <FilterComponent {...props}>
    <TextInput label="Search" source="name" alwaysOn />
    <SelectInput
      source="type"
      choices={[
        { id: 'book', name: 'Book' },
        { id: 'book_summary', name: 'Book summary' },
      ]}
      alwaysOn></SelectInput>
  </FilterComponent>
)

const CollectionList = props => (
  <List
    {...props}
    perPage={1000}
    pagination={<CollectionPagination />}
    filters={<CollectionFilter />}
    sort={{ field: 'updatedAt', order: 'DESC' }}>
    <Datagrid bulkActionButtons={false} rowClick={false}>
      <TextField source="name" />
      <FunctionField
        source="type"
        render={record => COLLECTION_TYPE[record.type]}
      />
      <TextField source="description" />
      <TextField source="slug" />
      <ReferenceField label="Created by" source="createdBy" reference="users">
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField label="Updated by" source="updatedBy" reference="users">
        <TextField source="name" />
      </ReferenceField>
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
      <EditButton />
      <DeleteButton undoable={false} />
    </Datagrid>
  </List>
)

export default CollectionList
